import { ActionTypes } from "@/App/constants/actionTypes";

type DownloadTestClaim = {
  type: typeof ActionTypes.DOWNLOAD_BATCH_TRANSMISSION_TEST_CLAIM;
  payload: string;
  file_type?: string;
};

export const downloadTestClaim = (id: string, file_type?: string): DownloadTestClaim => {

  const payload: DownloadTestClaim = {
    type: ActionTypes.DOWNLOAD_BATCH_TRANSMISSION_TEST_CLAIM,
    payload: id,
  };

  if (file_type) {
    payload.file_type = file_type;
  }

  return payload;
};

export type DownloadBatchTestClaimActions = DownloadTestClaim;
